export const UserAuthEmptyState: TokenState = {
  authorization: null,
  jwToken: null,
  ttl: 0,
  createdAt: 0,
  user: undefined,
  email: undefined,
};
